import ModalBox from './ModalBox';

export { type ModalBoxProps } from './ModalBox';

export default ModalBox;
